export enum EFontSize {
  s = 'small',
  m = 'medium',
  l = 'reg',
}
